import { Card, Table, Dropdown, Typography, Tag, Space } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Enums } from '../../../shared';
import UserCardAvatar from '../../common/UserCardAvatar';
import SubmissionDropdown from '../components/submissionActionsDropdown';
import { useUserProfileQuery } from '../../../features/auth/authApi';
import { isTeacher } from '../../../helpers/permissions';
import { Link } from 'react-router-dom';
import { useGetSubmissionInboxQuery } from '../../../features/courses/coursesApi';
import ClassOverviewPanel from '../../analytics/containers/ClassOverviewPanel';

const { Text } = Typography;

const submissionStatusTagColor = {
    [Enums.COURSE_STEP_EVALUATION_STATUS.WAITING]: 'warning',
    [Enums.COURSE_STEP_EVALUATION_STATUS.PASSED]: 'success',
    [Enums.COURSE_STEP_EVALUATION_STATUS.FAILED]: 'error',
    [Enums.COURSE_STEP_EVALUATION_STATUS.SUBMITTED]: 'processing',
};

const SubmissionsInbox = () => {
    const { t } = useTranslation();
    const { data: user } = useUserProfileQuery('userDetails');
    const { data: submissions } =
        useGetSubmissionInboxQuery('submission-inbox');

    const submissionStatusTagText = {
        [Enums.COURSE_STEP_EVALUATION_STATUS.WAITING]: t('waiting'),
        [Enums.COURSE_STEP_EVALUATION_STATUS.PASSED]: t('approved'),
        [Enums.COURSE_STEP_EVALUATION_STATUS.FAILED]: t('rejected'),
        [Enums.COURSE_STEP_EVALUATION_STATUS.SUBMITTED]: t('submitted'),
    };

    const columns = [
        {
            title: t('submissions.inboxTable.student'),
            dataIndex: 'issuer',
            key: 'issuer',
            width: '20%',
            render: (issuer) => <UserCardAvatar user={{ email: issuer }} />,
        },
        {
            title: t('submissions.inboxTable.status'),
            dataIndex: 'status',
            width: '10%',
            key: 'status',
            render: (status) => (
                <Tag color={submissionStatusTagColor[status]}>
                    {submissionStatusTagText[status]}
                </Tag>
            ),
        },
        {
            title: t('submissions.inboxTable.lesson'),
            key: 'context',
            width: '65%',
            render: (submission) => (
                <Link to={submission.file_link}>
                    <Card hoverable size="small">
                        <Space direction="horizontal" style={{ width: '100%' }}>
                            <Text strong>{submission.course_title}</Text>
                            <Text>{submission.title}</Text>
                        </Space>
                    </Card>
                </Link>
            ),
        },
        {
            title: '',
            key: 'action',
            width: '5%',
            render: (submission) => {
                if (isTeacher(user)) {
                    return <SubmissionDropdown submission={submission} />;
                }
            },
        },
    ];

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            {isTeacher(user) && <ClassOverviewPanel />}
            <Card title={t('submissions.inboxTable.header')} bodyStyle={{ padding: 0 }}>
                <Table
                    columns={columns}
                    dataSource={submissions}
                    rowKey={'id'}
                    expandable={{
                        expandedRowRender: (submission) => (
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Card title={submission.title}>
                                    <Text>{submission.description}</Text>
                                </Card>
                            </Space>
                        ),
                    }}
                />
            </Card>
        </Space>
    );
};

export default SubmissionsInbox;
